<script>
export default {
  name: 'MagicUiText',

  inject: {
    pop: {
      default: {},
    },
  },

  props: {
    config: {
      type: Object,
      default: () => ({}),
    },

    model: {
      type: [Object, Array],
      default() {
        return [];
      },
    },

    disabled: {
      type: [Boolean],
    },
  },

  data() {
    return {
      style: {},
      data: {},
      asyncContent: '',
    };
  },

  computed: {
    displayText() {
      if (this.asyncContent) {
        return this.asyncContent;
      }

      const { text } = this.config;

      if (this.disabled && this.config.disabledText) {
        return this.config.disabledText;
      }

      if (typeof text === 'function') {
        return text.bind(this)(this, { model: this.model });
      }

      if (text) {
        return text;
      }

      return '';
    },
  },

  created() {
    // 使用了 text 的富文本异步加载，异步加载富文本内容
    const { asyncLoad } = this.config;
    if (asyncLoad && asyncLoad.enable && !this.inMagic) {
      const { globalData } = this.app;
      const asyncKey = `magic-ui-text-${asyncLoad.url}`;
      const asyncContent = globalData[asyncKey];

      if (asyncContent) {
        this.asyncContent = asyncContent;
      } else {
        const baseUrl = this.inHippy ? window.tvConfig.tvRootUrl : location.origin;
        this.app.request({
          url: `${baseUrl}${asyncLoad.url}`,
        }).then((data) => {
          this.asyncContent = data;
          globalData[asyncKey] = data;
          if (this.pop) {
            this.$nextTick().then(() => {
              this.pop.pushIscrollEl(this.$el);
            });
          }
        })
          .catch(() => {
            this.asyncContent = '内容加载失败了，请尝试重新加载';
          });
      }
    }
  },

  render(h) {
    const className = this.config?.multiple ? 'magic-ui-text' : 'magic-ui-text magic-ui-text-sigle-line';
    if (this.$slots.default) {
      return h('span', {
        class: className,
      }, this.$slots.default);
    }
    if (this.inHippy) {
      return h('span', {
        class: className,
      }, this.displayText);
    }
    return h('span', {
      class: className,
      domProps: {
        innerHTML: this.displayText,
      },
    });
  },
};
</script>
